import { word } from "@modules/core/utils/i18n"
import { HUText } from "@modules/ui/components/huText"
import { useTheme } from "styled-components"

type BoxLeadFormHeaderProps = {
  isEdition?: boolean
  className?: string
} & React.ComponentProps<"div">

export function BoxLeadFormHeader({ isEdition, className, ...props }: BoxLeadFormHeaderProps) {
  const theme = useTheme()

  const defaultClassName = "flex flex-column gap-3 mt-4"

  return (
    <div className={className ?? defaultClassName} {...props}>
      <HUText fontStyle="TL" color={theme.mainWhite}>
        {isEdition ? word("box.lead.overview.header.title.edit") : word("box.lead.overview.header.title.add")}
      </HUText>
      <HUText fontStyle="BS" color={theme.neutralColor700}>
        {word("box.lead.overview.header.content.add")}
      </HUText>
    </div>
  )
}
